import BaseApi from "@/api";
import qs from "qs";

class PublicApi extends BaseApi {
  getCaptcha = () => this.request("/auth/captcha");
  getToken(config) {
    config.headers = {
      // Authorization: 'Basic ' + window.btoa('SyncClient:syncRenz12345'),
      "Content-Type": "application/x-www-form-urlencoded",
      "x-requested-with": "XMLHttpRequest",
    };
    config.data = qs.stringify(config.data);
    return this.request("/auth/oauth/token", "POST", config);
  }
  getRsaPublicKey = () => this.request("/auth/rsa");
  getDictionary = (config) => {
    return this.request("/common/dictionary", "GET", config);
  };
  getSystemGlobal = () => {
    return this.request("/iwrsms/systemGlobal/info", "GET");
  };
  currentAccount = (config) => {
    return this.request(`/auth/platform/currentAccount`, "GET", config);
  };
  menuVO = (platformCode) => {
    return this.request(`/auth/menu/MenuVO/${platformCode}`, "GET");
  };
  resetPassword = (config) => {
    return this.request(`/auth/account/resetPassword`, "POST", config);
  };
}

export default new PublicApi();
